// extracted by mini-css-extract-plugin
module.exports = {"container":"PageContainer_container__1-gZU cy-6 pb-6"};